export enum TipoMascara {
    Nenhuma = 0,
    Cpf = 1,
    Telefone = 2,
    Cep = 3,
}
